import { Button } from "@material-ui/core";
import { AssignmentOutlined } from "@material-ui/icons";
import { useHistory, useLocation } from "react-router-dom";

const RequestServiceReviewButton = ({ request, variant = 'contained' }) => {
    const history = useHistory();
    const location = useLocation();

    const handleClick = () => {
        if (request?.id) {
            if (location.pathname.includes(`/solicitations/${request.id}`)) {
                history.push(`${location.pathname}#review`);
            } else {
                history.push(`/solicitations/${request.id}#review`);
            }
        }
    }

    const getButton = () => ({
        contained: (
            <Button
                variant="contained"
                color="primary"
                startIcon={<AssignmentOutlined />}
                onClick={handleClick}
                style={{
                    textTransform: 'none',
                    fontWeight: 500
                }}
            >
                Detalhes da Revisão
            </Button>
        ),
        link: (
            <Button
                variant='text'
                color='primary'
                className="w-full"
                onClick={handleClick}
                style={{
                    textTransform: 'none'
                }}
            >
                <span className='text-sm'>Detalhes da Revisão</span>
            </Button>
        ),
        chip: (
            <Button
                variant="outlined"
                size="small"
                startIcon={<AssignmentOutlined />}
                onClick={handleClick}
                style={{
                    textTransform: 'none',
                    fontSize: '0.75rem',
                    padding: '4px 12px',
                    borderRadius: 16,
                    borderColor: '#1976d2',
                    color: '#1976d2'
                }}
            >
                Revisão
            </Button>
        )
    })[variant];

    return getButton();
}

export default RequestServiceReviewButton;
